function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameMenuTemplate = require('./game-menu.template');
var GameMenuIconTemplate = require('./game-menu-icon.template');
var GameMenuOptionTemplate = require('./game-menu-option.template');
var InviteLink = require('./../modals/saito-link/saito-link');
var jsonTree = require('json-tree-viewer');
var SaitoOverlay = require('./../saito-overlay/saito-overlay');

/**
 * A customizable menu system that sits along top of screen with click to open drop down lists of submenus
 * Menu actions are defined by callbacks passed through options objects and seperately stored in properties: icons, options, sub_options
 * this.options contains the top level menu items which (by default) open to display a list of submenu options
 * this.sub_options contains the details of the second and third tier submenu options (third tier submenus are contained as a array of objects within the submenu object)
 * this.icons are direct action items in the top-level menu
 *
 * GameMenu is included in GameTemplate and accessible through .menu
 * The menu should be defined (through addMenuOption, addSubMenuOption, and addMenuIcon) in the game module's initializeHTML
 * As usual, render and attachEvents must also be called in the module.
 */
var GameMenu = /*#__PURE__*/function () {
  /**
   * @param app - the Saito application
   * @param mod - reference to the game module
   */
  function GameMenu(app, mod) {
    _classCallCheck(this, GameMenu);
    this.app = app;
    this.game_mod = mod;
    this.icons = [];
    this.options = [];
    this.sub_options = [];
    this.sub_menu_open = '';
    this.initialized = 0;
    this.debug = true;
    this.overlay = new SaitoOverlay(app, mod);
    this.lock = null;
    this.container = '#saito-header';
  }

  /**
   * Creates the Menu in the DOM if it doesn't already exist
   * Menu must be defined using the other functions prior to rendering!
   */
  return _createClass(GameMenu, [{
    key: "render",
    value: function render() {
      var menu_self = this;
      console.log('rendering menu... ' + this.initialized);
      if (this.initialized == 0) {
        // *************************************************
        this.addMenuOption('game-share', 'Share');
        var _iterator = _createForOfIteratorHelper(this.app.modules.respondTo('game-menu', this.game_mod)),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var menMod = _step.value;
            var menu = menMod.respondTo('game-menu', this.game_mod);
            if (menu.init) {
              menu.init(this.app, this.game_mod);
            }
            if (menu !== null && menu !== void 0 && menu.id && menu !== null && menu !== void 0 && menu.text) {
              this.addMenuOption(menu.id, menu.text);
            }
            var _iterator2 = _createForOfIteratorHelper(menu.submenus),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var sub_menu = _step2.value;
                this.addSubMenuOption(sub_menu.parent, sub_menu);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        this.initialized = 1;

        //Insert Standard functions here
        if (this.game_mod.opengame) {
          this.addSubMenuOption('game-share', {
            text: 'Join Link',
            id: 'game-link',
            "class": 'game-link',
            callback: function callback(app, game_mod) {
              var _game_mod$returnSlug, _game_mod$returnSlug2;
              game_mod.menu.hideSubMenus();
              var data = {
                game: (_game_mod$returnSlug = (_game_mod$returnSlug2 = game_mod.returnSlug) === null || _game_mod$returnSlug2 === void 0 ? void 0 : _game_mod$returnSlug2.call(game_mod)) !== null && _game_mod$returnSlug !== void 0 ? _game_mod$returnSlug : game_mod.name,
                game_id: game_mod.game.id,
                path: '/arcade/',
                name: 'Join'
              };
              var link = new InviteLink(app, game_mod, data);
              link.render();
            }
          });
        } else if (this.game_mod.enable_observer) {
          this.addSubMenuOption('game-share', {
            text: 'Observer Link',
            id: 'game-link',
            "class": 'game-link',
            callback: function callback(app, game_mod) {
              var _game_mod$returnSlug3, _game_mod$returnSlug4;
              game_mod.menu.hideSubMenus();
              var data = {
                game: (_game_mod$returnSlug3 = (_game_mod$returnSlug4 = game_mod.returnSlug) === null || _game_mod$returnSlug4 === void 0 ? void 0 : _game_mod$returnSlug4.call(game_mod)) !== null && _game_mod$returnSlug3 !== void 0 ? _game_mod$returnSlug3 : game_mod.name,
                game_id: game_mod.game.id,
                step: game_mod.game.step.game,
                path: '/arcade/',
                name: 'Observer'
              };
              var link = new InviteLink(app, game_mod, data);
              link.render();
            }
          });
        }
        if (this.debug || this.game_mod.debug) {
          this.addSubMenuOption('game-game', {
            text: 'Debug',
            id: 'game-debug',
            "class": 'game-debug',
            callback: function callback(app, game_mod) {
              game_mod.menu.hideSubMenus();
              menu_self.overlay.show("<div class=\"debug_overlay\">\n      <button class=\"saito-button-primary\" id=\"checkmoves\">Check for missed transaction</button>\n      <div class=\"debug-stats\"><span>Gaming Active</span><span>".concat(game_mod.gaming_active, "</span><span>Halted</span><span>").concat(game_mod.halted, "</span><span>Game run initialized</span><span>").concat(game_mod.initialize_game_run, "</span></div>\n         </div>"));

              //debug info
              var el = document.querySelector('.debug_overlay');
              if (!game_mod.styles.includes('/saito/lib/jsonTree/jsonTree.css')) {
                game_mod.styles.push('/saito/lib/jsonTree/jsonTree.css');
                game_mod.attachStyleSheets();
              }
              try {
                var optjson = JSON.parse(JSON.stringify(game_mod.game, function (key, value) {
                  return typeof value === 'bigint' ? value.toString() : value;
                } // return everything else unchanged
                ));
                var tree = jsonTree.create(optjson, el);
              } catch (err) {
                console.log('error creating jsonTree: ' + err);
              }
              var btn = document.getElementById('checkmoves');
              if (btn) {
                btn.onclick = /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
                    return _regenerator().w(function (_context) {
                      while (1) switch (_context.n) {
                        case 0:
                          e.stopPropagation();
                          btn.onclick = null;
                          btn.classList.add('disabled');
                          btn.innerHTML = 'fetching';
                          game_mod.fetchRecentGameMoves();
                        case 1:
                          return _context.a(2);
                      }
                    }, _callee);
                  }));
                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }();
              }
            }
          });
        }
        this.addSubMenuOption('game-game', {
          text: 'Export',
          id: 'game-export',
          "class": 'game-export',
          callback: function callback(app, game_mod) {
            game_mod.exportGame();
          }
        });
        this.addSubMenuOption('game-game', {
          text: 'Exit',
          id: 'game-exit',
          "class": 'game-exit',
          callback: function callback(app, game_mod) {
            game_mod.exitGame();
          }
        });
        this.addMenuIcon({
          text: '<i class="fa fa-window-maximize" aria-hidden="true"></i>',
          id: 'game-menu-fullscreen',
          callback: function callback(app, game_mod) {
            game_mod.menu.hideSubMenus();
            app.browser.requestFullscreen();
          }
        });
      }
      var html = "<ul>";
      for (var i = 0; i < this.icons.length; i++) {
        html += GameMenuIconTemplate(this.icons[i]);
      }
      for (var _i = 0; _i < this.options.length; _i++) {
        html += GameMenuOptionTemplate(this.options[_i], this.sub_options[_i]);
      }
      html += "<div id=\"game-menu-toggle\" class=\"game-menu-mobile-toggle\"><i class=\"fas fa-bars\"></i></div></ul>";
      if (document.getElementById('game-menu')) {
        this.app.browser.replaceElementById(GameMenuTemplate(html), 'game-menu');
      } else {
        if (document.querySelector(this.container)) {
          this.app.browser.prependElementToSelector(GameMenuTemplate(html), this.container);
        } else {
          this.app.browser.addElementToDom(GameMenuTemplate(html));
        }
      }
      this.attachEvents();
    }

    /**
     * Add functionality to menu so that clicking on menu items evokes their callbacks
     * If callback is undefined for top-level menu options, default behavior is to attempt to open its submenu
     */
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      if (this.app.browser.isMobileBrowser(navigator.userAgent) || window.innerWidth < 600 || window.innerHeight < 600) {
        //We really need the makeDraggable to prevent propagation of click events
        //this.app.browser.makeDraggable("game-menu", "game-menu", true);

        document.body.addEventListener('click', function (e) {
          if (!document.querySelector('.game-menu').contains(e.target)) {
            _this.hideSubMenus(true);
          }
        });
      }

      //
      // callbacks in game-menu-option
      //
      for (var i = 0; i < this.options.length; i++) {
        var menu = document.querySelector('#' + this.options[i].id);
        if (menu) {
          menu.ontouch = function (e) {
            var id = e.currentTarget.id;
            e.currentTarget.classList.remove('notification');
            for (var _i2 = 0; _i2 < _this.options.length; _i2++) {
              if (_this.options[_i2].id === id) {
                if (_this.sub_menu_open === id) {
                  //keep mobile menue visible
                  _this.hideSubMenus(false);
                } else {
                  if (_this.options[_i2].callback != undefined) {
                    _this.options[_i2].callback(_this.app, _this.game_mod);
                  } else {
                    _this.showSubMenu(id);
                  }
                }
                e.stopPropagation();
                return;
              }
            }
          };
          menu.onclick = function (e) {
            var id = e.currentTarget.id;
            e.currentTarget.classList.remove('notification');
            for (var _i3 = 0; _i3 < _this.options.length; _i3++) {
              if (_this.options[_i3].id === id) {
                if (_this.sub_menu_open === id) {
                  //Toggle submenu by clicking it
                  _this.hideSubMenus(false);
                } else {
                  if (_this.options[_i3].callback != undefined) {
                    _this.options[_i3].callback(_this.app, _this.game_mod);
                  } else {
                    _this.showSubMenu(id);
                  }
                }
                e.stopPropagation();
                return;
              }
            }
          };
          menu.onmouseleave = function (e) {
            if (!_this.lock) {
              _this.hideSubMenus(false);
            }
          };
        }
      }

      //
      // sub-menu
      //
      for (var _i4 = 0; _i4 < this.sub_options.length; _i4++) {
        for (var ii = 0; ii < this.sub_options[_i4].length; ii++) {
          var submenu = document.querySelector('#' + this.sub_options[_i4][ii].id);
          if (submenu) {
            submenu.ontouch = function (e) {
              e.currentTarget.classList.remove('notification');
              var menuObj = _this.returnMenuFromID(e.currentTarget.id);
              if (menuObj !== null && menuObj !== void 0 && menuObj.callback) {
                menuObj.callback(_this.app, _this.game_mod);
                e.stopPropagation();
                return;
              }
            };
            submenu.onclick = function (e) {
              e.currentTarget.classList.remove('notification');
              e.stopPropagation();
              var menuObj = _this.returnMenuFromID(e.currentTarget.id);
              if (menuObj !== null && menuObj !== void 0 && menuObj.callback) {
                menuObj.callback(_this.app, _this.game_mod);
                return;
              }
              if (_this.lock) {
                _this.hideSubSubMenu(_this.lock);
              }
              if (_this.lock === e.currentTarget.id) {
                _this.lock = null;
              } else {
                _this.lock = e.currentTarget.id;
              }
              _this.showSubSubMenu(e.currentTarget.id);
            };
            submenu.onmouseover = function (e) {
              var id = e.currentTarget.id;
              if (!_this.lock) {
                _this.showSubSubMenu(id);
              }
              e.stopPropagation();
              return;
            };
            submenu.onmouseleave = function (e) {
              if (!_this.lock) {
                var id = e.currentTarget.id;
                _this.hideSubSubMenu(id);
                e.stopPropagation();
                return;
              }
            };
            //Sub-sub-menus
            if (this.sub_options[_i4][ii].sub_menu) {
              for (var j = 0; j < this.sub_options[_i4][ii].sub_menu.length; j++) {
                var ssubmenu = document.querySelector('#' + this.sub_options[_i4][ii].sub_menu[j].id);
                if (ssubmenu) {
                  ssubmenu.onclick = function (e) {
                    var menuObj = _this.returnMenuFromID(e.currentTarget.id);
                    if (menuObj !== null && menuObj !== void 0 && menuObj.callback) {
                      menuObj.callback(_this.app, _this.game_mod);
                      e.stopPropagation();
                      return;
                    }
                  };
                }
              }
            }
          }
        }
      }

      //
      // callbacks in game-menu-icon
      //
      for (var _i5 = 0; _i5 < this.icons.length; _i5++) {
        var _menu = document.querySelector('#' + this.icons[_i5].id);
        if (_menu) {
          _menu.onclick = function (e) {
            var menuObj = _this.returnMenuFromID(e.currentTarget.id);
            if (menuObj !== null && menuObj !== void 0 && menuObj.callback) {
              menuObj.callback(_this.app, _this.game_mod);
              e.stopPropagation();
              return;
            }
          };
          _menu.ontouch = function (e) {
            var menuObj = _this.returnMenuFromID(e.currentTarget.id);
            if (menuObj !== null && menuObj !== void 0 && menuObj.callback) {
              menuObj.callback(_this.app, _this.game_mod);
              e.stopPropagation();
              return;
            }
          };
        }
      }
      var mobileToggle = document.querySelector('#game-menu-toggle');
      if (mobileToggle) {
        mobileToggle.onclick = function (e) {
          e.currentTarget.classList.remove('notification');
          var menu = document.querySelector('.game-menu');
          if (menu) {
            if (menu.classList.contains('mobile-visible')) {
              _this.hideSubMenus();
            } else {
              menu.classList.add('mobile-visible');
            }
          }
        };
      }
    }

    /**
     * Helper function to seach the class properties for the menu object based on its id
     * Note, all menu id's should be unique!
     */
  }, {
    key: "returnMenuFromID",
    value: function returnMenuFromID(id) {
      //Icons
      for (var i = 0; i < this.icons.length; i++) {
        if (this.icons[i].id === id) {
          return this.icons[i];
        }
      }
      //Menu
      for (var _i6 = 0; _i6 < this.options.length; _i6++) {
        if (this.options[_i6].id === id) {
          return this.options[_i6];
        }
      }
      //Submenu
      for (var _i7 = 0; _i7 < this.sub_options.length; _i7++) {
        for (var j = 0; j < this.sub_options[_i7].length; j++) {
          if (this.sub_options[_i7][j].id === id) {
            return this.sub_options[_i7][j];
          }
          if (this.sub_options[_i7][j].sub_menu) {
            for (var k = 0; k < this.sub_options[_i7][j].sub_menu.length; k++) {
              if (this.sub_options[_i7][j].sub_menu[k].id === id) {
                return this.sub_options[_i7][j].sub_menu[k];
              }
            }
          }
        }
      }
      return null;
    }
  }, {
    key: "replaceMenuByID",
    value: function replaceMenuByID(options) {
      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].id === options.id) {
          this.options[i] = options;
          if (options !== null && options !== void 0 && options.submenus) {
            // Delete existing sub_options first
            this.sub_options[i] = [];

            // Re-add!
            var _iterator3 = _createForOfIteratorHelper(options.submenus),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var s = _step3.value;
                this.addSubMenuOption(options.id, s);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
          break;
        }
      }
      this.render();
    }

    /**
     * Hide the menu from the DOM
     */
  }, {
    key: "hide",
    value: function hide() {
      try {
        document.querySelector('.game-menu').style.display = 'none';
      } catch (err) {
        console.log('Cannot hide menu?');
      }
    }

    /**
     * Add a top-level menu option to the menu
     * @param options -- an object containing id, text, class, and callback
     * id is a unique reference to the menu item (will not permit duplicate ids),
     * text is what is displayed in the menu,
     * class (if defined) is passed along to the html template for css styling or query selection
     * callback is the function to run on clicking. Generally, that should be a reference to this.showSubMenu
     *
     *
     */
  }, {
    key: "addMenuOption",
    value: function addMenuOption(id, text) {
      if (this.returnMenuFromID(id)) {
        return;
      }
      var options = {
        id: id,
        text: text,
        "class": id,
        callback: function callback(app, game_mod) {
          game_mod.menu.showSubMenu(id);
        }
      };
      this.options.push(options);
      this.sub_options.push([]);
    }

    /**
     * Adds a sub menu to a top-level menu option or to a secondary menu option (sub_option)
     * @param parent_id -- the id of the containing top-level menu item
     * @param options -- an object containing id, text, class, and callback
     * id is a unique reference to the menu item (will not permit duplicate ids),
     * text is what is displayed in the menu,
     * class (if defined) is passed along to the html template for css styling or query selection
     * callback is the function to run on clicking. Generally, that should be a function defined in the game module
     *
     *
     */
  }, {
    key: "addSubMenuOption",
    value: function addSubMenuOption(parent_id) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!options.id) {
        console.error('No menu id specified!');
        return;
      }

      //if (this.returnMenuFromID(options.id)) {
      //  //console.error("Duplicate menu id:",options.id);
      //  return;
      //}

      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].id === parent_id) {
          if (this.sub_options[i]) {
            for (var j = 0; j < this.sub_options[i].length; j++) {
              if (this.sub_options[i][j].id == options.id) {
                this.sub_options[i][j] = options;
                return 1; // replacement
              }
            }
            this.sub_options[i].push(options);
            return 1; //addition!
          }
        }
      }

      //Sub-sub menu --> we only reach here if the specified parent_id is not a top level menu
      var parentMenu = this.returnMenuFromID(parent_id);
      if (!parentMenu) {
        console.error('Invalid menu parent');
        console.log('Target id: ' + parent_id);
        console.log(options);
        return;
      }
      if (parentMenu.sub_menu) {
        parentMenu.sub_menu.push(options);
      } else {
        parentMenu.sub_menu = [];
        parentMenu.sub_menu.push(options);
      }
    }

    /**
     * Add a top-level menu option to the menu
     * @param options -- an object containing id, text, class, and callback
     * id is a unique reference to the menu item (will not permit duplicate ids),
     * text is what is displayed in the menu,
     * class (if defined) is passed along to the html template for css styling or query selection
     * callback is the function to run on clicking. Generally, that should be a reference to this.showSubMenu
     *
     * menuIcon differs from menuOption in that menuOption assumes there is a subMenu, while menuIcon results in a direct action
     * A typical example of icon text is the html: '<i class="fa fa-window-maximize" aria-hidden="true"></i>'
     */
  }, {
    key: "addMenuIcon",
    value: function addMenuIcon() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      for (var i = 0; i < this.icons.length; i++) {
        if (this.icons[i].id == options.id) {
          return;
        }
      }
      this.icons.push(options);
    }

    /**
     * Opens the specified submenu (closing any currently open one)
     * @param parent_id - the id of the menu option containing the submenu to be openeed
     */
  }, {
    key: "showSubMenu",
    value: function showSubMenu(parent_id) {
      if (this.sub_menu_open != '') {
        this.hideSubMenus(false);
      }
      this.sub_menu_open = parent_id;
      var el = document.querySelector('#' + parent_id + ' > ul');
      if (el) {
        el.style.display = 'block';
      }
    }

    /**
     * Sets the sub menu the specified menu to display
     * Only differs from showSubMenu because we don't want to close all the submenus
     * @param parent_id - the id of the (sub)menu option containing the submenu to be openeed
     */
  }, {
    key: "showSubSubMenu",
    value: function showSubSubMenu(parent_id) {
      var el = document.querySelector('#' + parent_id + ' > ul');
      if (el) {
        el.style.display = 'block';

        //if (this.lock)
        //this.hideSubMenus(e.currentTarget.parentElement);
      }
    }

    /**
     * Hides all submenus
     *
     */
  }, {
    key: "hideSubMenus",
    value: function hideSubMenus() {
      var activeClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.sub_menu_open = '';
      this.lock = null;
      for (var i = 0; i < this.options.length; i++) {
        var divname = '#' + this.options[i].id + ' ul';
        var subLists = document.querySelectorAll(divname);
        for (var _i8 = 0; _i8 < subLists.length; _i8++) {
          if (subLists[_i8]) {
            subLists[_i8].style.display = 'none';
          }
        }
      }
      var menu = document.querySelector('.game-menu');
      if (menu && activeClose) {
        menu.classList.remove('mobile-visible');
      }
    }

    /**
     * Hide the menu contained within the specified parent id
     * @param parent_id - the id of the <li> containing the submenu
     */
  }, {
    key: "hideSubSubMenu",
    value: function hideSubSubMenu(parent_id) {
      var div = document.querySelector("#".concat(parent_id, " ul"));
      if (div) {
        div.style.display = 'none';
      }
    }

    /**
     * A convienence function for game modules to quickly add chat features to the game menu
     * @param names - an optional specification of player names, if not provided, defaults to Player 1, Player 2, etc.
     */
  }, {
    key: "addChatMenu",
    value: function addChatMenu() {
      var _this2 = this,
        _this$game_mod,
        _menu_self$game_mod;
      var shortNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var longNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var menu_self = this;

      //
      // it is such a pain in the ass to get the object returned by a module's
      // respondTo function
      //

      var chat = this.app.modules.respondTo('saito-game-menu');
      var cm = null;
      if ((chat === null || chat === void 0 ? void 0 : chat.length) > 0) {
        var chat2 = chat[0].respondTo('saito-game-menu');
        if ((chat2 === null || chat2 === void 0 ? void 0 : chat2.length) > 0) {
          cm = chat2[0];
        }
      }
      if (!cm) {
        return;
      }
      cm.event('game-chat-manager');

      //
      //Add notifications to the game-menu for chat events
      //
      this.app.connection.on('chat-popup-render-request', function () {
        var chat_group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        if (_this2.initialized) {
          try {
            if (!chat_group || chat_group.unread == 0) {
              return;
            }
            document.getElementById('game-social').classList.add('notification');
            document.getElementById('game-chat').classList.add('notification');
            document.getElementById('game-menu-toggle').classList.add('notification');
            document.getElementById('game-social').classList.add('new-notification');
            document.getElementById('game-menu-toggle').classList.add('new-notification');
            if (chat_group.members.length == 1) {
              document.getElementById('game-chat-community').classList.add('notification');
            } else if (chat_group.members.length >= 2) {
              document.getElementById('game-chat-group').classList.add('notification');
            } else {}
            setTimeout(function () {
              document.getElementById('game-social').classList.remove('new-notification');
              document.getElementById('game-menu-toggle').classList.remove('new-notification');
            }, 1000);
          } catch (err) {
            //console.warn(err);
          }
        }
      });
      this.addMenuOption('game-social', 'Chat');

      //
      // Create group chat but just for this game, not the whole community
      //
      if (((_this$game_mod = this.game_mod) === null || _this$game_mod === void 0 || (_this$game_mod = _this$game_mod.game) === null || _this$game_mod === void 0 || (_this$game_mod = _this$game_mod.players) === null || _this$game_mod === void 0 ? void 0 : _this$game_mod.length) > 1) {
        // DM
        var key = this.game_mod.game.opponents[0];

        // Group
        if (this.game_mod.game.players.length > 2) {
          key = this.game_mod.game.players.slice();
        }

        // Open table
        if (this.game_mod.opengame) {
          key = false;
        }
        if (!this.app.browser.isMobileBrowser()) {
          this.app.connection.on('chat-ready', function () {
            if (_this2.game_mod.game.players.length > 2 || _this2.game_mod.opengame) {
              _this2.app.connection.emit('open-chat-with', {
                key: key,
                name: _this2.game_mod.returnName() + ' Chat',
                id: _this2.game_mod.game.id,
                temporary: true
              });
            } else {
              _this2.app.connection.emit('open-chat-with', {
                key: key
              });
            }
            _this2.app.connection.emit('chat-manager-request-no-interrupts');
          });
        }
        var chat_title = 'Player Chat';
        if (this.game_mod.game.players.length > 2) {
          chat_title = 'Game Chat';
        }
        this.addSubMenuOption('game-social', {
          text: chat_title,
          id: 'game-chat-group',
          "class": 'game-chat-group',
          callback: function callback(app, game_mod) {
            menu_self.hideSubMenus();
            if (game_mod.game.players.length > 2 || game_mod.opengame) {
              //Create an on-the-fly chat group for 3+ players
              app.connection.emit('open-chat-with', {
                key: key,
                name: game_mod.returnName() + ' Chat',
                id: game_mod.game.id,
                temporary: true
              });
            } else {
              //Default DM with 1-to-1 games
              app.connection.emit('open-chat-with', {
                key: key
              });
            }
            app.connection.emit('chat-manager-request-no-interrupts');
          }
        });
      }
      if (((_menu_self$game_mod = menu_self.game_mod) === null || _menu_self$game_mod === void 0 || (_menu_self$game_mod = _menu_self$game_mod.game) === null || _menu_self$game_mod === void 0 || (_menu_self$game_mod = _menu_self$game_mod.players) === null || _menu_self$game_mod === void 0 ? void 0 : _menu_self$game_mod.length) > 2) {
        var _loop = function _loop(z) {
          if (menu_self.game_mod.game.player != z + 1) {
            menu_self.addSubMenuOption('game-social', {
              text: "".concat(menu_self.game_mod.returnUsername(menu_self.game_mod.game.players[z])),
              id: "game-chat-group-".concat(z + 1),
              "class": "game-chat-group-".concat(z + 1),
              callback: function callback(app, game_mod) {
                menu_self.hideSubMenus();
                menu_self.app.connection.emit('open-chat-with', {
                  key: menu_self.game_mod.game.players[z]
                });
              }
            });
          }
        };
        for (var z = 0; z < menu_self.game_mod.game.players.length; z++) {
          _loop(z);
        }
      }
      menu_self.addSubMenuOption('game-social', {
        text: 'More Chats',
        id: 'game-chat-manager',
        "class": 'game-chat-manager',
        callback: function callback(app, game_mod) {
          menu_self.hideSubMenus();
          cm.callback();
        }
      });
    }
  }]);
}();
module.exports = GameMenu;